import { Auth0Provider } from '@auth0/auth0-react';
import { Toaster } from 'react-hot-toast';
import { BrowserRouter } from 'react-router';
import { ErrorBoundary } from '@src/components/ErrorBoundary';
import { I18nComponentStringsProvider } from '@src/components/I18nComponentStringsProvider/I18nComponentStringsProvider';
import PagesRoot from '../pages';
import { config } from '../services/config';
import AppApolloProvider from './AppApolloProvider';

function App(): JSX.Element {
  return (
    <I18nComponentStringsProvider>
      <ErrorBoundary>
        <Auth0Provider
          domain={config.VITE_AUTH0_DOMAIN}
          clientId={config.VITE_AUTH0_CLIENT_ID}
          authorizationParams={{
            redirect_uri: `${window.location.origin}/auth/auth0-callback`,
            audience: config.VITE_AUTH0_AUDIENCE,
            scope: 'openid profile email offline_access',
          }}
          // refresh tokens avoid the hidden-iframe silent auth flow, which
          // breaks wherever the Auth0 session cookie is cross-site (eg. localhost)
          useRefreshTokens
          cacheLocation="localstorage"
          skipRedirectCallback
        >
          <AppApolloProvider>
            <BrowserRouter>
              <PagesRoot />
              <Toaster />
            </BrowserRouter>
          </AppApolloProvider>
        </Auth0Provider>
      </ErrorBoundary>
    </I18nComponentStringsProvider>
  );
}

export default App;
